import {Component, HostListener, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent {

  // Store Data
  isBrowser:boolean;
  isServer:boolean;

  // Header fixed for scroll
  headerFixed = false;


  constructor(
    @Inject(PLATFORM_ID) public platform:any
  ) {
    this.isBrowser = isPlatformBrowser(this.platform);
    this.isServer = isPlatformServer(this.platform);
  }

  /**
   * Header fixed function
   * scrollBody()
  */
  @HostListener('window:scroll')
  scrollBody() {
    if (window.scrollY > 0) {
      this.headerFixed = true;
    }
    else {
      this.headerFixed = false;
    }
  }

}
